import {Injectable} from '@angular/core';
import {LocalisationModule} from './localisation.module';
import {TranslateService} from '@ngx-translate/core';
import _ from 'lodash-firecloud';

export enum LocaleLangs {
  english = 'en',
  swedish = 'sv'
}

@Injectable({
  providedIn: LocalisationModule
})
export class LocalisationService {
  private readonly translate: TranslateService;

  public constructor(translate: TranslateService) {
    this.translate = translate;
  }

  public start(): void {
    this.translate.addLangs([
      LocaleLangs.english,
      LocaleLangs.swedish
    ]);
    this.translate.setDefaultLang(LocaleLangs.english);
    let browserLang = this.translate.getBrowserLang();

    let chosenLang = _.includes(this.translate.getLangs(), browserLang) ? browserLang : LocaleLangs.english;
    this.translate.use(chosenLang);
  }
}
